import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ThemeModule } from '../../@theme/theme.module';
import { TotalCourseListComponent } from './totalcourselist.component';
import { NbListModule } from '@nebular/theme';
import { NbAlertModule } from '@nebular/theme';
import { NbButtonModule } from '@nebular/theme';
import { YoutubePlayerComponent } from 'ngx-youtube-player';
import { NbDialogModule } from '@nebular/theme';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {NgxPaginationModule} from 'ngx-pagination';
import { SharedModule } from './../../pages/shared-authpipe.module';
import { Routes,RouterModule } from '@angular/router';

let routes:Routes=[
  {     
    path:'',
    component:TotalCourseListComponent
  }
]   
@NgModule({
    imports: [
        ThemeModule,
        CommonModule,
        FormsModule,
        NbListModule,
        NbAlertModule,
        NbButtonModule,
        NgxPaginationModule,
        YoutubePlayerComponent,
        SharedModule,
        NgxMaterialTimepickerModule,
        NbDialogModule.forRoot(),
        RouterModule.forChild(routes)
    ],
    declarations: [
        TotalCourseListComponent
    ]
})
  export class TotalCourseListModule {
  }
